export app from './app';
export brokers from './brokers';
export calendar from './calendar';
export cryptocurrencies from './cryptocurrencies';
export commodities from './commodities';
export device from './device';
export dividends from './dividends';
export funds from './funds';
export currencies from './currencies';
export insiders from './insiders';
export indices from './indices';
export interests from './interests';
export notices from './notices';
export orders from './orders';
export overview from './overview';
export search from './search';
export stocks from './stocks';
export tickers from './tickers';
export trades from './trades';



/** WEBPACK FOOTER **
 ** /src/shared/redux/reducers.js
 **/